import { useMemo } from 'react'
import { any, entries, pipe, prop } from 'lodash/fp'
import { useTranslation } from 'react-i18next'

import {
	createChoices,
	isFilterbaleField,
	isPreproField,
	toAdaptedSchema,
	useColumnsSchemaQuery,
} from '@/entities/column'
import {
	useBrandsQuery,
	useCategoriesQuery,
	useSettingsSchemasQuery,
} from '@/entities/core'

import { HiddenOnContext } from '@/shared/generated'
import {
	getResolvedSchema,
	translateSchemaKeys,
} from '@/shared/tools/json-schema-utils'

export const useStopListSettingsData = () => {
	const { t } = useTranslation()

	/**Queries */
	const defaultRulesSchema = useSettingsSchemasQuery({
		select: pipe([
			getResolvedSchema('entity:scenario'),
			(schema) => translateSchemaKeys(schema, t),
			prop(
				'properties.settings.properties.stop_list.properties.default_rules.properties'
			),
			entries,
		]),
	})
	const fieldsQuery = useColumnsSchemaQuery(HiddenOnContext.Assortment, {
		select: (data) => data.filter(isPreproField).filter(isFilterbaleField),
	})
	const brandsQuery = useBrandsQuery({})
	const categoriesQuery = useCategoriesQuery({})
	const dataChoices = useMemo(() => {
		const schema = fieldsQuery.data || []

		return createChoices({
			schema,
			entities: {
				brand: brandsQuery.data || [],
				category: categoriesQuery.data || [],
			},
		})
	}, [brandsQuery.data, categoriesQuery.data, fieldsQuery.data])

	const fields = useMemo(
		() => (fieldsQuery.data || []).map((schema) => toAdaptedSchema(schema, t)),
		[fieldsQuery.data, t]
	)
	const isLoading = any(prop('isLoading'), [
		defaultRulesSchema.isLoading,
		fieldsQuery.isLoading,
		brandsQuery.isLoading,
		categoriesQuery.isLoading,
	])

	return {
		fields,
		dataChoices,
		isLoading,
		defaultRulesSchema: defaultRulesSchema.data || [],
	}
}
